const GermanyFlag = () => (
  <svg width="16" height="12" viewBox="0 0 30 20" style={{ marginRight: '4px', verticalAlign: 'middle' }}>
    <rect width="30" height="6.67" fill="#000000"/>
    <rect y="6.67" width="30" height="6.67" fill="#DD0000"/>
    <rect y="13.33" width="30" height="6.67" fill="#FFCC00"/>
  </svg>
);

export default GermanyFlag;